import { Routes, Route } from 'react-router-dom';

// user registration
import Login from './pages/Auth/Login';

// booking management
import Booking from './pages/Booking/Booking';
import CreateBooking from './pages/Booking/CreateBooking';
import BookingDetail from './pages/Booking/BookingDetail';
import EditBooking from './pages/Booking/EditBooking';
import ConfirmBooking from './pages/Booking/ConfirmBooking';

import Vehicle from './pages/Vehicle/Vehicle';
import CreateVehicle from './pages/Vehicle/CreateVehicle';
import EditVehicle from './pages/Vehicle/EditVehicle';

import Navbar from './components/Navbar';
import './App.css';
import { useAuth } from './context/AuthContext';

function App() {

  const {loading} = useAuth();

  if (loading) return <div className="text-center mt-5">Loading...</div>;

  return (
    <div className="App">
      <Navbar />
      <Routes>
        <Route path="/login" element={<Login />} />
        <Route path='/bookings' element={<Booking />} />
        <Route path="/create-booking" element={<CreateBooking />} />
        <Route path="/bookings/:id" element={<BookingDetail />} />
        <Route path="/bookings/:id/edit" element={<EditBooking />} />
        <Route path="/bookings/:bookingId/confirm" element={<ConfirmBooking />} />


        <Route path='/vehicles' element={<Vehicle />} />
        <Route path="/create-vehicle" element={<CreateVehicle />} />
        <Route path="/vehicles/:id/edit" element={<EditVehicle />} />

      </Routes>
    </div>
  );
}

export default App;
